<template>
  <div class="clients">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Markets</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Spot Markets</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- <div class="row">
          <div class="col-md-12">-->
          <balance></balance>
          <!-- </div>
          </div>-->

          <!-- Search Filter -->
          <div class="row filter-row"></div>
          <!-- Search Filter -->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <!-- {{coinList}} -->
                <table class="table table-striped custom-table mb-0 datatable">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Price</th>
                      <!-- <th>24h Change</th> -->
                      <th>24h High / 24h Low</th>
                      <th>24h Volume</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(row,index) in coinList">
                      <spot-markets :markets="row" :key="index"></spot-markets>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->

        <!-- Add Client Modal -->

        <!-- /Add Client Modal -->

        <!-- edit client -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import SpotMarkets from "./spotmarkets.vue";
import Balance from "./balance.vue";
//import LeftSidebar from "./LeftSidebar.vue";

import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    SpotMarkets,
    Balance
  },
  data() {
    return {
      loading: false,
      connection: null
    };
    //  isactive : true
  },
  computed: {
    coinList() {
      return this.$store.state.binance.coinList;
    }
  },
  async created() {
    let param = [];
    this.$store.dispatch("binance/actKlineData", param);
  },
  methods: {},
  mounted() {
    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "binance"
};
</script>


// WEBPACK FOOTER //
// src/views/binance/index.vue